import api from './api';

export const licencaService = {
  getAll,
  getById,
  create,
  update,
  destroy
};

function getAll(page = 1, limit = 25, status = '', query = '') {
  let queryStr = `?page=${page}&limit=${limit}${status && `&status=${status}`}${query && `&query=${query}`}`;
  return api.get(`${process.env.VUE_APP_ROOT_API}/licencas${queryStr}`);
}

function getById(id) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/licencas/${id}`);
}

function create(licenca) {
  return api.post(`${process.env.VUE_APP_ROOT_API}/licencas`, licenca);
}

function update(licenca) {
  return api.put(`${process.env.VUE_APP_ROOT_API}/licencas/${licenca._id}`, licenca);
}

function destroy(id) {
  return api.delete(`${process.env.VUE_APP_ROOT_API}/licencas/${id}`);
}